import { IElectricVehicleType } from "@/services/UsageEstimationService/types"

const electricVehicleTypes: IElectricVehicleType[] = [
  {
    batteryCapacity: 40,
    range: 150,
    name: "Nissan LEAF (2018) ~ 40kW Battery ~ 3.75 mile / kW",
  },
  {
    batteryCapacity: 100,
    range: 320,
    name: "Tesla Model S 100D ~ 100kW Battery ~ 3.20 mile / kW",
  },
]
export default electricVehicleTypes
